import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map, forEach, includes } from "lodash";

import { fetchPost } from "../../../api/fetch";

import { setBreadcrumb } from "../../../actions/common";

import Grid from "@material-ui/core/Grid";

import MdcForm from "./MdcForm";
import MdcTab from "./MdcTab";
import MdcEntranceExit from "./MdcEntranceExit";
import MdcTotalActiveProfiles from "./MdcTotalActiveProfiles";
//import MdcDashboard1CsvExport from "./MdcDashboard1CsvExport";

import { calculatePercentage } from "../../../utils/data";

import {
  entrances,
  exits,
  car,
  truck,
  trailer,
} from "../../../constants/common";

const total = "total";

const styles = {
  tabContent: {
    margin: "0px 12px 12px",
    padding: "12px",
    maxWidth: "900px",
  },
};

const MdcDashboard1 = (props) => {
  const { dispatch, classes } = props;
  const [data, setData] = React.useState();
  const [displayedData, setDisplayedData] = React.useState(total);

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: "dashboards",
          display: false,
        },
        {
          name: I18n.get("topbar_mdcDashboard1"),
        },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const search = async (filters) => {
    try {
      setData();
      let operational = await fetchPost("/system/statistics/operational", {
        start: get(filters, ["startDate"]),
        end: get(filters, ["endDate"]),
      });
      let total = {
        cars: {},
        trucks: {},
        trailers: {},
        misc: { license_plates: {}, total_number_of_profiles: {} },
      };
      forEach(get(operational, ["DAC Entrance"]), (v, k) => {
        let totalKeys = Object.keys(total);
        if (includes(totalKeys, k)) {
          forEach(v, (value, key) => {
            if (typeof value === "object") {
              forEach(value, (vv, kk) => {
                total[k][key][kk] =
                  vv + get(operational, ["DAC Exit", k, key, kk]);
              });
            } else {
              total[k][key] = value + get(operational, ["DAC Exit", k, key]);
            }
          });
        }
      });
      total.total =
        get(operational, ["DAC Entrance", "total"]) +
        get(operational, ["DAC Exit", "total"]);
      setData({
        entrances: get(operational, ["DAC Entrance"]),
        exits: get(operational, ["DAC Exit"]),
        misc: get(operational, ["misc"]),
        total,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const getDeltas = (section) => {
    return [
      {
        title: I18n.get(
          `dashboard_${displayedData === entrances ? "exits" : "entrances"}`
        ),
        value: get(data, [
          displayedData === entrances ? exits : entrances,
          section,
          "total",
        ]),
        delta:
          displayedData === total
            ? null
            : get(data, [
                displayedData === entrances ? exits : entrances,
                section,
                "total",
              ]) - get(data, [displayedData, section, "total"]),
      },
      {
        title: I18n.get(
          `dashboard_${displayedData === total ? "exits" : "total"}`
        ),
        value: get(data, [
          displayedData === total ? exits : total,
          section,
          "total",
        ]),
        delta: null,
      },
    ];
  };

  return (
    <Grid container direction="column" className="height-100">
      <Grid item xs style={{ overflow: "auto", padding: "12px" }}>
        <Grid container direction="column">
          <Grid item>
            <MdcForm search={search} language={props.language} />
          </Grid>
          <Grid item style={{ zIndex: 10, padding: "12px 12px 0px 18px" }}>
            <Grid container>
              {map(
                [
                  {
                    key: total,
                    title: I18n.get("stats_total"),
                    value:
                      get(data, [entrances, "total"]) +
                      get(data, [exits, "total"]),
                  },
                  {
                    key: entrances,
                    title: I18n.get("dashboard_entrances"),
                    value: get(data, [entrances, "total"]),
                  },
                  {
                    key: exits,
                    title: I18n.get("dashboard_exits"),
                    value: get(data, [exits, "total"]),
                  },
                ],
                (item) => (
                  <MdcTab
                    key={item.key}
                    title={item.title}
                    value={item.value}
                    active={item.key === displayedData}
                    onClick={() => setDisplayedData(item.key)}
                  />
                )
              )}
            </Grid>
          </Grid>
          <Grid item className={`mainContent ${classes.tabContent}`}>
            {/* <MdcDashboard1CsvExport data={data} displayedData={displayedData} /> */}
            <Grid container>
              <MdcEntranceExit
                type={car}
                total={get(data, [displayedData, "cars", "total"])}
                percentage={calculatePercentage(
                  get(data, [displayedData, "cars", "total"]),
                  get(data, [displayedData, "total"])
                )}
                data={[
                  {
                    title: I18n.get("dashboard_withPlate"),
                    value: get(data, [displayedData, "cars", "with_plate"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "cars", "with_plate"]),
                      get(data, [displayedData, "cars", "total"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_lprMatch"),
                    value: get(data, [displayedData, "cars", "lpr_match"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "cars", "lpr_match"]),
                      get(data, [displayedData, "cars", "with_plate"])
                    ),
                  },
                ]}
                deltas={getDeltas("cars")}
                licensePlates={{
                  value: get(data, [
                    displayedData,
                    "misc",
                    "license_plates",
                    "number_of_distinct_lp_of_car",
                  ]),
                  total: get(data, [
                    displayedData,
                    "misc",
                    "license_plates",
                    "license_plates",
                  ]),
                }}
              />
              <MdcEntranceExit
                type={truck}
                total={get(data, [displayedData, "trucks", "total"])}
                percentage={calculatePercentage(
                  get(data, [displayedData, "trucks", "total"]),
                  get(data, [displayedData, "total"])
                )}
                data={[
                  {
                    title: I18n.get("dashboard_withPlate"),
                    value: get(data, [displayedData, "trucks", "with_plate"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trucks", "with_plate"]),
                      get(data, [displayedData, "trucks", "total"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_lprMatch"),
                    value: get(data, [displayedData, "trucks", "lpr_match"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trucks", "lpr_match"]),
                      get(data, [displayedData, "trucks", "with_plate"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_withOcr"),
                    value: get(data, [displayedData, "trucks", "with_ocr"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trucks", "with_ocr"]),
                      get(data, [displayedData, "trucks", "total"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_ocrMatch"),
                    value: get(data, [displayedData, "trucks", "ocr_match"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trucks", "ocr_match"]),
                      get(data, [displayedData, "trucks", "with_ocr"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_driverFrAttempt"),
                    value: get(data, [
                      displayedData,
                      "trucks",
                      "driver_fr_attempt",
                    ]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trucks", "driver_fr_attempt"]),
                      get(data, [displayedData, "trucks", "total"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_withTrailer"),
                    value: get(data, [displayedData, "trucks", "with_trailer"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trucks", "with_trailer"]),
                      get(data, [displayedData, "trucks", "total"])
                    ),
                  },
                ]}
                deltas={getDeltas("trucks")}
                licensePlates={{
                  value: get(data, [
                    displayedData,
                    "misc",
                    "license_plates",
                    "number_of_distinct_lp_of_trucks",
                  ]),
                  total: get(data, [
                    displayedData,
                    "misc",
                    "license_plates",
                    "license_plates",
                  ]),
                }}
              />
              <MdcEntranceExit
                type={trailer}
                total={get(data, [displayedData, "trailers", "total"])}
                percentage={calculatePercentage(
                  get(data, [displayedData, "trailers", "total"]),
                  get(data, [displayedData, "total"])
                )}
                data={[
                  {
                    title: I18n.get("dashboard_withPlate"),
                    value: get(data, [displayedData, "trailers", "with_plate"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trailers", "with_plate"]),
                      get(data, [displayedData, "trailers", "total"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_lprMatch"),
                    value: get(data, [displayedData, "trailers", "lpr_match"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trailers", "lpr_match"]),
                      get(data, [displayedData, "trailers", "with_plate"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_withOcr"),
                    value: get(data, [displayedData, "trailers", "with_ocr"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trailers", "with_ocr"]),
                      get(data, [displayedData, "trailers", "total"])
                    ),
                  },
                  {
                    title: I18n.get("dashboard_ocrMatch"),
                    value: get(data, [displayedData, "trailers", "ocr_match"]),
                    percentage: calculatePercentage(
                      get(data, [displayedData, "trailers", "ocr_match"]),
                      get(data, [displayedData, "trailers", "with_ocr"])
                    ),
                  },
                ]}
                deltas={getDeltas("trailers")}
                licensePlates={{
                  value: get(data, [
                    displayedData,
                    "misc",
                    "license_plates",
                    "number_of_distinct_lp_of_trailres",
                  ]),
                  total: get(data, [
                    displayedData,
                    "misc",
                    "license_plates",
                    "license_plates",
                  ]),
                }}
              />
            </Grid>
          </Grid>
          <MdcTotalActiveProfiles data={data} />
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(MdcDashboard1));
